import { GridSize } from '@material-ui/core'
import { orgSelectors } from 'ducks/orgs'
import { permissionsSelectors } from 'ducks/permissions'
import { useHidePricing } from 'hooks/useHidePricing'
import { useSelector } from 'react-redux'
import useHardwareSelectorV2Columns from './useHardwareSelectorV2Columns'

type ExtendedGridSize = GridSize | false

interface ColumnWidths {
  item: ExtendedGridSize
  brand: ExtendedGridSize
  name: ExtendedGridSize
  rating: ExtendedGridSize
  stock: ExtendedGridSize
  price: ExtendedGridSize
  source: ExtendedGridSize
  qty?: ExtendedGridSize
  action: ExtendedGridSize
}

const useComponentSelectorColumnWidth = (type: 'hardware' | 'inverterWizard'): ColumnWidths => {
  const hidePricing = useHidePricing()
  const { showDistributorSelection } = useHardwareSelectorV2Columns()
  const hasEnabledDistributors = (useSelector(orgSelectors.getEnabledHardwareSuppliers)?.length ?? 0) > 0

  const distributorPricingRolePermission = useSelector((state) =>
    permissionsSelectors.getPermissionByKey(state, 'shop_hardware_access')
  )
  const hardwareComponentPricingPermission = useSelector((state) =>
    permissionsSelectors.getPermissionByKey(state, 'component_pricing_costing')
  )

  const shouldDisplayStockPriceSource =
    !hidePricing && distributorPricingRolePermission.allowView && hasEnabledDistributors

  // Stock column removed – stock and View location are shown under supplier chips in the source column
  const stockValue = 0
  let priceValue = 0
  let sourceValue = 0
  if (shouldDisplayStockPriceSource && hardwareComponentPricingPermission.allowView) priceValue = 2
  if (shouldDisplayStockPriceSource && showDistributorSelection) sourceValue = 2
  const remaining = 4 - (stockValue + priceValue + sourceValue) // remaining free space/columns

  let nameValue = type === 'inverterWizard' ? 2 : 3
  let actionValue = 1
  if (remaining > 0) {
    nameValue += Math.ceil(remaining / 2)
    actionValue += Math.floor(remaining / 2)
  }

  return {
    item: 1,
    brand: 2,
    name: nameValue as GridSize,
    rating: 1,
    stock: stockValue === 0 ? false : (stockValue as GridSize),
    price: priceValue === 0 ? false : (priceValue as GridSize),
    source: sourceValue === 0 ? false : (sourceValue as GridSize),
    action: actionValue as GridSize,
    ...(type === 'inverterWizard' && { qty: 1 as GridSize }),
  }
}

export default useComponentSelectorColumnWidth
